import { DealsQueries, PipelineDimensionOption } from "store/types";

/**
 * The five Group By dimensions supported by the backend (`deals_group_by`). `key` is the lowercase value
 * sent to the API; `label` is shown to the user. This set is fixed by the API contract.
 */
export const PIPELINE_GROUP_DIMENSIONS: PipelineDimensionOption[] = [
  { key: "asset_class", label: "Asset Class" },
  { key: "sub_asset_class", label: "Sub Asset Class" },
  { key: "currency", label: "Currency" },
  { key: "geography", label: "Geography" },
  { key: "vintage", label: "Vintage" }
];

/**
 * Default Card details LIST (checkbox rows) — the design's base minus Investor/Manager. The user can grow this
 * list via "Add Characteristic". Names are sent verbatim as `card_characteristics` when checked.
 */
export const PIPELINE_CARD_BASE_CHARACTERISTICS: string[] = ["Asset Class", "Geography", "Sub Asset Class", "Vintage"];

/** Default CHECKED characteristics (subset of the list) shown on the card. */
export const PIPELINE_DEFAULT_CARD_CHARACTERISTICS: string[] = ["Asset Class", "Geography", "Sub Asset Class"];

/** Max characteristics that can be shown on a pipeline card (per design: "Up to 5 items can be used in the card"). */
export const PIPELINE_MAX_CARD_CHARACTERISTICS = 5;

/** Max nesting depth of pipeline grouping (Asset class > Sub asset class). */
export const PIPELINE_MAX_GROUP_DEPTH = 2;

export enum DealViews {
  Dashboard = "dashboard",
  PIPELINE = "pipeline",
  GRID = "grid",
  TABLE = "table"
}

export enum DealsOrderBy {
  TITLE = "title",
  LAST_MODIFIED = "last_updated_relation",
  LATEST_CREATED = "created_at"
}

export const defaultDealsQueries: DealsQueries = {
  filters: { "Asset Class": [], "Deal Status": [] },
  deal_title: "",
  view: DealViews.PIPELINE,
  order_by: DealsOrderBy.LAST_MODIFIED,
  tableColumns: [],
  cubicInvestorView: {},
  chartInvestorView: {}, //we receive this from server
  summaryTableInvestorView: {
    measures: ["Commitment"],
    characteristics: [],
    calculatedFields: ["Adjusted NAV", "IRR", "MOIC", "DPI"]
  },
  descriptionTableInvestorView: {
    measures: ["Commitment"],
    characteristics: [],
    calculatedFields: []
  },
  dealListGroupBy: [],
  pipelineGroupBy: [],
  pipelineCardCharacteristics: PIPELINE_DEFAULT_CARD_CHARACTERISTICS,
  pipelineCardCharacteristicOptions: PIPELINE_CARD_BASE_CHARACTERISTICS,
  pipelineHiddenStageIds: []

  // tableColumns: [
  //   "title",
  //   "created_at",
  //   "asset_class",
  //   "sub_asset_class",
  //   "deal_status",
  //   "deal_stage",
  //   "minimum_ticket",
  //   "geography"
  // ],
  // cubicInvestorView: {
  //   ["cubic1"]: { title: "All Deals", filter: "All Deals" },
  //   ["cubic2"]: { title: "MOIC", filter: "MOIC" },
  //   ["cubic3"]: { title: "IRR", filter: "IRR" }
  // },
};

export interface IOpportunitiesStatuses {
  INTERESTED: "interested";
  LATER: "later";
  APPLY: "apply";
}

export const opportunityStatuses: IOpportunitiesStatuses = {
  INTERESTED: "interested",
  LATER: "later",
  APPLY: "apply"
};
export const FileUnderScanningMessage = "We are scanning files for malware, files will be available soon.";

export enum DealRedirect {
  FirstFolderMeta = "firstFolderMeta",
  FirstForm = "firstForm",
  Dashboard = "dashboard",
  Workspace = "workspace",
  FirstDocument = "firstDocument"
}

export const DATABOX_MIN_WIDTH_PX = 300;
export const DATABOX_MAX_WIDTH_PX = 600;

export const REQUIRED_FOR_STAGE_KEY = "requiredForStage";
export const MISSING_FIELD_IDS_KEY = "missingFieldIds";
export const TARGET_STAGE_NAME_KEY = "targetStageName";
export const MISSING_FIELD_NAMES_KEY = "missingFieldNames";
/** When opening from "Review missing fields" while already on deal page, ensures URL changes so the drawer opens again */
export const REVIEW_TRIGGER_KEY = "reviewTrigger";
